import { render, staticRenderFns } from "./DashBoardView.vue?vue&type=template&id=3b4a0f2d&scoped=true"
import script from "./DashBoardView.vue?vue&type=script&lang=js"
export * from "./DashBoardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4a0f2d",
  null
  
)

export default component.exports